import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

import { ViewBreakpointService } from '@common-module/app-services/view-breakpoint.service';
import { SensorName } from '@common-module/modelinterfaces/enums/sensor-name';
import { SensorTypeName } from '@common-module/modelinterfaces/enums/sensor-type-name';
import { SensorLastValue } from '@common-module/modelinterfaces/sensor-last-value.model';
import { UnitAdditionalData } from '@common-module/modelinterfaces/unit-additional-data.model';
import { NgClass, AsyncPipe } from '@angular/common';
import { SecToStringDurationPipe } from '@common-module/pipes/sec-to-string-duration.pipe';
import { SensorValuePipe } from '@common-module/pipes/sensor-value.pipe';

@Component({
    selector: 'app-unit-status-card',
    templateUrl: './unit-status-card.component.html',
    styleUrls: ['../carousel-card-styles.component.scss'],
    imports: [NgClass, AsyncPipe, SecToStringDurationPipe, TranslateModule, SensorValuePipe]
})

export class UnitStatusCardComponent implements OnChanges {

  @Input() width: number;
  @Input() unitData: UnitAdditionalData;

  public sensorGpsSpeed: SensorLastValue;
  public sensorOnBoardVoltage: SensorLastValue;

  constructor(public viewBreakpointService: ViewBreakpointService,
              public translateService: TranslateService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['unitData']) {
      this.sensorGpsSpeed = this.unitData.getSensorLastValueByName(SensorName.SPEED);
      this.sensorOnBoardVoltage = this.unitData.getSensorLastValueByType(SensorTypeName.ONBOARD_VOLTAGE);
    }
  }
}
